/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentSkillsPathParams = NonNullable<operations['listAgentSkills']['parameters']['path']>;

export type ListAgentSkillsQueryParams = NonNullable<operations['listAgentSkills']['parameters']['query']>;

export interface Input extends ListAgentSkillsPathParams {
  apiVersion?: string;
  query?: ListAgentSkillsQueryParams;
}

export async function listAgentSkills(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/skills', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
